import { useState } from "react";
import ProgramCard from "./ProgramCard";
import MapView from "./MapView";

const ListeCarte = ({ listeDesProgrammes }) => {
  const [position, setPosition] = useState({
    lng: listeDesProgrammes[0]?.longitude || 2.3488,
    lat: listeDesProgrammes[0]?.latitude || 48.8534,
  });

  const [selectedProgramId, setSelectedProgramId] = useState(
    listeDesProgrammes[0]?.documentId
  );

  return (
    <div className="d-flex flex-column">
      <div className="d-flex p-0 gap10 mt-10 position-relative">
        <div className="w50">
          <ProgramCard
            listeDesProgrammes={listeDesProgrammes}
            setPosition={setPosition}
            selectedProgramId={selectedProgramId}
            setSelectedProgramId={setSelectedProgramId}
          />
        </div>
        <div
          className="w50 position-sticky top-0"
          style={{ height: "max-content" }}
        >
          <MapView locations={listeDesProgrammes} position={position} />
        </div>
      </div>
    </div>
  );
};

export default ListeCarte;
